export const ultimasNoticias = [
    {
        "imagen" : "../img/noticias/Corto2026_1.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : " 🎥 CONVOCATORIA 🎞️ ",
        "fecha" : " Concurso Nacional de Transparencia en Corto 2026"
    },
    //  {
    //     "imagen" : "../img/noticias/ventanilla/1.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/2.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/3.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/4.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/5.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/6.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/7.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/8.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/9.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/10.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
    //   {
    //     "imagen" : "../img/noticias/ventanilla/11.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyos y Subsidios 2026"
    // },
     
    
]
